<template>
  <div class="api-layer">
    <fieldset>
      <legend>RoomCall-Mixer</legend>

      <div class="api-box">
        <label class="api-title">info</label>
        <button @click="getMixerInfo">OK</button>
        <div
            v-if="!!callInfo.desc"
        >
          <pre>{{ callInfo.desc }}</pre>
        </div>
      </div>

      <div class="api-box">
        <label class="api-title">mixerId</label>
        roomId:<input type="text" name="roomId" />
        <button @click="getMixerId">OK</button>
        <div class="desc-inline"></div>
      </div>

      <div class="api-box">
        <label class="api-title">recreate</label>
        roomId:<input type="text" name="roomId" />
        <button @click="recreate">OK</button>
      </div>

      <div class="api-box">
        <label class="api-title">reEnter roomUser</label>
        roomId:<input type="text" name="roomId" />
        userId:<input type="text" name="userId" />
        <button @click="reEnter">OK</button>
      </div>

    </fieldset>
  </div>
</template>

import {SysAdmin} from "@/core/sysadmin/sysadmin.api";

<script>
import {SysAdmin} from "@/core/sysadmin/sysadmin.api";
import SysAdminBase from "@/components/Sysadmin/SysAdminBase";

export default {
  name: "RoomCallMixer",
  mixins: [SysAdminBase],
  data() {
    return {
      callInfo: {
        desc: null
      },
    }
  },

  methods: {
    async recreate(e) {
      const roomId = this.getRoomIdValue(e);
      if(!roomId) return;

      if(!confirm('go?')) return;

      await SysAdmin.post({
        url: '/room/call/mixer/recreate',
        params: {roomId}
      })
    },
    async reEnter(e) {
      const roomId = this.getRoomIdValue(e);
      if(!roomId) return;

      const userId = this.getUserIdValue(e);
      if(!userId) return;

      if(!confirm('go?')) return;

      await SysAdmin.post({
        url: '/room/call/mixer/roomUser/reEnter',
        params: {roomId, userId}
      })
    },
    ...(() => {
      const methods = {
        async getMixerInfo(e) {
          const data = await SysAdmin.get({url: '/call/mixer/info'})
          console.log(data);
          this.callInfo.desc = data;
        },
        async getMixerId(e) {
          const roomId = this.getRoomIdValue(e);
          if(!roomId) return;

          this.writeDescInline(e, {msg: ''});

          const data = await SysAdmin.get({url: '/call/mixer/getMixerId', params: {roomId}})
          console.log(data);

          this.writeDescInline(e, {msg: data});
        },
      }

      return SysAdmin.createDebounceMethods(methods);
    })(),
  },
}
</script>

<style lang="scss" scoped>

</style>